<template>
  <div>
    <!-- 发表最新动态 -->
    <div class="fabiaodongtai">
      <div class="dongtai">
        <textarea
          cols="30"
          rows="10"
          :placeholder="this.texts"
          @click="isFabiao"
          v-model="text"
        ></textarea>
      </div>
      <!-- 分享范围区域 -->
      <el-button
        type="primary"
        round
        size="mini"
        :style="isfabiao === false ? 'display:none' : 'display:block'"
        @click="fabiao"
        >发表</el-button
      >
    </div>

    <!-- 发表按钮 -->
    <el-button
      type="primary"
      round
      size="mini"
      v-show="isFaBiao"
      @click="fabiao"
      >发表</el-button
    >
  </div>
</template>

<script>
import URL from "../../api/index";
import axios from "axios";
export default {
  data() {
    return {
      UserInfo: "",
      getSpaceinfo: "",
      //   是否显示发表框
      isfabiao: false,
      //   是否显示评论框的发表
      isFaBiao: false,
      text: "",
      texts: "给ta留个言呗?",
      iteminfo: "",
      spaceid: "",
    };
  },
  mounted() {
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    this.iteminfo = JSON.parse(window.localStorage.getItem("iteminfo"));
    if (this.iteminfo) {
      this.spaceid = this.iteminfo.space_id;
    } else {
      this.spaceid = this.getSpaceinfo.space_id;
    }
  },
  methods: {
    //   点击对话框(显示发发表框)
    isFabiao() {
      this.isfabiao = true;
      this.texts = "";
    },
    //数据上报
    getRecordRjw(hh, model) {
      var that = this;
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_publish",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的发表功能",
          data: {
            function: "留言板",
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            content: that.text,
            content_id: model,
          },
        };
        axios
          .post("http://47.114.114.56:9002/RecordRjw", saydata)
          .then((res) => {
            this.$emit("shuaxin", 10);
            that.text = "";
            that.texts = "给ta留个言呗?";
          });
      });
    },
    fabiao() {
      var that = this;
      var getspace_data = {
        token: that.UserInfo.token,
        content: that.text,
        space_id: that.spaceid,
      };
      //  发表留言
      this.$post(URL.addguestbook, getspace_data).then((res) => {
        if (res.state == 0) {
          // 数据上报
          this.getRecordRjw(
            JSON.parse(localStorage.getItem("loginInfo")),
            res.result.gsb_id
          );
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.fabiaodongtai {
  box-sizing: border-box;
  width: 877px;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(15, 26, 47, 0.06);
  border-radius: 4px;
  color: #898989;
  position: relative;
  overflow: hidden;
  .dongtai {
    height: 69px;
    border-bottom: 1px solid #efefef;
    overflow: hidden;
    textarea {
      border: solid 0px;
      resize: none;
      width: 100%;
      text-indent: 2rem;
      height: 100%;
      border: 0;
      float: left;
      outline: none;
      font-size: 16px;
      font-family: MicrosoftYaHei;
    }
    i {
      float: right;
      font-size: 30px;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }
  }
  .el-button {
    float: right;
    margin: 8px 20px 8px 0;
  }
}
textarea::-webkit-input-placeholder {
  line-height: 70px;
}
</style>
